import { Position, Toaster } from "@blueprintjs/core";

export const AppToaster = Toaster.create({
  position: Position.BOTTOM,
  canEscapeKeyClear: true
});

export const TooltipToaster = Toaster.create({
  position: Position.TOP,
  canEscapeKeyClear: true
});



// WEBPACK FOOTER //
// ./src/app/toaster.js